import React, { useState, useContext } from "react";
import cogoToast from "cogo-toast";
import { navigate, A } from "hookrouter";
import AuthContext from "../../contexts/AuthContext";
import { FaHeart, FaEye, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import styles from "./Episode.module.css";
import EpisodeComments from "./EpisodeComments";
import Loading from "../Loading/Loading";
import { useEpisodes, useSingleEpisode } from "./EpisodeHooks";
import api from "../../actions/common";
import EpisodeHeader from "./EpisodeHeader";

const Episode = ({ storyID, episodeID, myStory }) => {
  const { token } = useContext(AuthContext);
  const [episode, loadingEpisode] = useSingleEpisode(storyID, episodeID);
  const [episodes, loading] = useEpisodes(storyID);
  const [votes, setVotes] = useState(0);

  React.useEffect(() => {
    if (episode) {
      setVotes(episode.totalVotes);
      console.log(episode);
    }
  }, [episode]);

  React.useEffect(() => {
    if (episodes) {
      console.log(episodes);
    }
  }, [episodes]);

  const voteForEpisode = () => {
    (async () => {
      const rawResponse = await fetch(
        `https://api.yazbie.com/api/episodes/postVote/${episodeID}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          cogoToast.success(content.message);
          setVotes(votes + 1);
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        console.log(await rawResponse.clone().text());
        cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const addBookmark = async () => {
    const rawResponse = await fetch(
      `https://api.yazbie.com/api/bookmarks/create/`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          episodeId: episodeID,
          bookmarkSlug: episode.Story.title,
        }),
      }
    );
    try {
      let content = await rawResponse.clone().json();
      console.log(content);
      if (content && content.success) {
        cogoToast.success(content.message);
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      console.log(err);
      console.log(await rawResponse.clone().text());
      cogoToast.error(await rawResponse.clone().text());
    }
  };

  const postReading = async (episodeID, token, setLoading) => {
    const response = await api.get(
      `/episodes/reading/${episodeID}`,
      token,
      {},
      setLoading
    );

    if (!(response.status || response.success)) {
      console.log(response);
      return;
    }
  };

  React.useEffect(() => {
    const setLoading = () => {
      return false;
    };
    postReading(episodeID, token, setLoading);
  }, []);

  if (loading || loadingEpisode || !episode) return <Loading />;

  return (
    <div className={styles.episode}>
      <EpisodeHeader
        episode={episode}
        storyID={storyID}
        episodeID={episodeID}
        voteForEpisode={voteForEpisode}
        addBookmark={addBookmark}
        myStory={myStory}
      />
      <div className={styles.main}>
        <div className={styles.wrapper}>
          <div>
            <div className={styles.title}>
              {episode.episodeName}
              <div>
                <FaEye /> {episode.totalReadNo}
              </div>
              <div>
                <FaHeart /> {votes}
              </div>
            </div>
            <A
              href={`/user/${episode.Story?.postedBy?.author}`}
              className={styles.author}
            >
              <div
                className={styles.avatar}
                style={{
                  backgroundImage: `url(${"https://images.unsplash.com/photo-1593153014720-2655782328c9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"})`,
                }}
              />
              <div className={styles.name}>
                {episode.Story?.postedBy.name || "Author Name"}
              </div>
            </A>
          </div>
          <div className={styles.divider} />
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: episode.episodeContent }}
          />
        </div>
        <div className={styles.pageNavButtons}>
          <div
            onClick={() =>
              navigate(`/episode/${storyID}/${episodes[(episode.episodeNumber - 1) - 1]._id}`)
            }
            className={(episode.episodeNumber - 1) !== 0 ? "" : styles.noshow}
          >
            <FaChevronLeft />
            Previous
          </div>

          <div
            onClick={() =>
              navigate(`/episode/${storyID}/${episodes[(episode.episodeNumber - 1) + 1]._id}`)
            }
            className={(episode.episodeNumber - 1) < episodes.length - 1 ? "" : styles.noshow}
          >
            Next <FaChevronRight />
          </div>
        </div>
        <div className={styles.divider} />
        <EpisodeComments episodeID={episodeID} />
      </div>
    </div>
  );
};

export default Episode;
